// extracted by mini-css-extract-plugin
export var activityContainer = "_ic-0";
export var typingIndicatorContainer = "_ic-1";
export var typingIndicatorDot = "_ic-2";
export var wave = "_ic-3";